/* eslint-disable react/prop-types, no-unused-vars */
import { Box, Button, Link } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../context/UserContext';
import logo from '../img/logo-tagline.svg';
import displayHandle from '../utils/displayHandle';
import HashIcon from './Icons/HashIcon';

const styles = {
  footerContainer: {
    backgroundColor: (theme) => theme.palette.primary.main,
    paddingTop: '36px',
    paddingBottom: '33px',
    padding: '36px 22px 33px 22px',
  },
  buttons: {
    display: 'block',
    width: '100%',
    marginBottom: '24px',
    textAlign: 'center',
  },
  buttonPrivacyPolicy: {
    display: 'block',
    width: '100%',
    marginBottom: '24px',
    textAlign: 'center',
    color: "#fff",
    backgroundColor: (theme) => theme.palette.primary.main,
  },
  logo: {
    margin: '0 auto',
    marginTop: '5px',
    width: '107px',
    display: 'block',
  },
};

export default function Footer() {
  const { loading, user } = useCurrentUser();
  const navigate = useNavigate();

  let buttons = [
    {
      text: 'Quick Guides',
      target: '/quick-guides',
      color: 'main',
    },
    {
      text: 'FAQ',
      target: '/faq',
      color: 'main',
    },
    {
      text: 'Support',
      target: '/support',
      color: 'main',
    },
  ];

  if (!loading && user !== null) {
    // Add the user-specific buttons
    buttons = [
      {
        text: displayHandle(user),
        target: `/user/${user?._id}`,
        color: 'main',
      },
      {
        text: (
          <Box display="flex" justifyContent="center">
            <HashIcon style={{ stroke: '#fff' }} /> Groups{' '}
          </Box>
        ),
        target: `/user/${user?._id}/groups`,
        color: 'main',
      },
      ...buttons,
    ];
  } else {
    // Add the sign-up and log in buttons
    buttons = [
      { text: 'Sign-Up', color: 'primary', target: '/signup' },
      { text: 'Log In', color: 'secondary', target: '/login' },
      ...buttons,
    ];
  }

  return (
    <Box sx={[styles.footerContainer]}>
      {buttons.map((button) => (
        <Button
          key={button.text}
          variant="contained"
          disableElevation
          color={button.color}
          sx={styles.buttons}
          onClick={() => navigate(button.target)}
        >
          {button.text}
        </Button>
      ))}
      <Button
        variant="contained"
        disableElevation
        component={Link}
        href="https://myy.org/privacy-policy/"
        target="_blank"
        rel="noopener"
        sx={styles.buttonPrivacyPolicy}
      >
        Privacy Policy
      </Button>
      <img src={logo} alt="Amplo logo" style={styles.logo} />
    </Box>
  );
}
